// extracted by mini-css-extract-plugin
export default {"holder":"styles_holder__qEPzH","calendar":"styles_calendar__WI4gx","icon":"styles_icon__faYkM"};